import moment from 'moment-timezone';
import tzlookup from 'tz-lookup';

function parseCoord(value) {
    const n = parseFloat(value);
    return Number.isFinite(n) ? n : null;
}

export function resolveTimezone(lat, lng) {
    const latitude = parseCoord(lat);
    const longitude = parseCoord(lng);
    if (latitude == null || longitude == null) {
        return { ok: false, error: 'Event location (latitude/longitude) is required for schedule times' };
    }
    try {
        const tz = tzlookup(latitude, longitude);
        if (!tz) {
            return { ok: false, error: 'Unable to resolve timezone for event location' };
        }
        return { ok: true, timezone: tz };
    } catch {
        return { ok: false, error: 'Unable to resolve timezone for event location' };
    }
}

export function hasValidCoords(lat, lng) {
    return parseCoord(lat) != null && parseCoord(lng) != null;
}

export function utcScheduleToLocal(storedDate, slots, lat, lng) {
    const tzResult = resolveTimezone(lat, lng);
    if (!tzResult.ok) return tzResult;

    if (!storedDate) {
        return { ok: false, error: 'Stored date is required' };
    }
    if (!Array.isArray(slots)) {
        return { ok: false, error: 'Slots array is required' };
    }

    const baseUtc = moment.utc(storedDate);
    if (!baseUtc.isValid()) {
        return { ok: false, error: 'Invalid stored date' };
    }

    const utcDateKey = baseUtc.format('YYYY-MM-DD');
    const localSlots = slots.map((slot) => {
        const startM = moment.tz(`${utcDateKey} ${slot.startTime}`, 'YYYY-MM-DD HH:mm', 'UTC').tz(tzResult.timezone);
        const endM = moment.tz(`${utcDateKey} ${slot.endTime}`, 'YYYY-MM-DD HH:mm', 'UTC').tz(tzResult.timezone);
        return {
            ...slot,
            startTime: startM.format('HH:mm'),
            endTime: endM.format('HH:mm'),
        };
    });

    const firstLocal = moment.tz(
        `${utcDateKey} ${slots[0]?.startTime || '00:00'}`,
        'YYYY-MM-DD HH:mm',
        'UTC'
    ).tz(tzResult.timezone);

    return {
        ok: true,
        timezone: tzResult.timezone,
        schedule: {
            date: firstLocal.format('YYYY-MM-DD'),
            slots: localSlots,
        },
    };
}

export function utcDateRowToLocal(row, lat, lng) {
    if (!row) return row;
    const slots = Array.isArray(row.slots) ? row.slots : [];
    if (!slots.length) {
        const tzResult = resolveTimezone(lat, lng);
        if (!tzResult.ok) return row;
        const localDate = moment.utc(row.date).tz(tzResult.timezone).format('YYYY-MM-DD');
        return { ...row, date: localDate };
    }
    const r = utcScheduleToLocal(row.date, slots, lat, lng);
    if (!r.ok) return row;
    return {
        ...row,
        date: r.schedule.date,
        slots: r.schedule.slots,
    };
}
